<template>
	<div>
		<NuxtPwaManifest />
		<NuxtLoadingIndicator />
		<NuxtLayout>
			<NuxtPage />
		</NuxtLayout>
		<PwaUpdate :auto-reload="false" />
	</div>
</template>

<style>


body {
	background-color: #fff;
	/*font-family:'Consolas', 'Lucidia Console', 'Monaco', 'Courier New', Courier, monospace;*/
	font-family: 'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif;
}
.v-card-title {
	margin-top: 20px;
	width: 100%;
	font-weight: bold;
	border-bottom: 1px solid #000;
}
.bolded {
	font-weight: bold;
	font-size: 1.1em;
}


.v-label {
	font-size: .9em;
	white-space: normal;
  	word-break: break-word;
  	overflow-wrap: anywhere;
	margin-bottom:5px;
	margin-top:5px;
}
.v-field__input {
	font-size: 1em;
}
.v-field__field {
	padding: 0px;
	margin: 0px;
}
.v-input__control {
	padding: 1px;
}
.v-selection-control__input {
	font-size: 0.7em;
}
.alert-success {
	background-color: #4caf50;
}
.case-header {
	background-color: red;
}
.header-text {
	font-size: 1.1rem;
}


</style>
